<template>
  <a-layout class="s_bf">
    <a-card :bordered="false">
      <a-form ref="ruleForm" :rules="rules" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol" :scrollToFirstError="true">
        <a-form-item label="码类型" name='label_type' v-if="label_type=='big'">
          <a-select v-model:value="form.label_type" :style="{width:'350px'}" :disabled="type=='edit'">
            <a-select-option :value="2">中箱码</a-select-option>
            <a-select-option :value="1">箱码</a-select-option>
          </a-select>
          <a-tooltip placement='right'>
            <template #title>仅支持套标类型的“箱码”和“盒码”设置营销活动。
            </template>
            <InfoCircleOutlined class="m-l-10 s_c376" />
          </a-tooltip>
        </a-form-item>
        <a-form-item ref="activity_name" label="活动名称" name="activity_name" required>
          <a-input v-model:value="form.activity_name" placeholder='请输入活动名称' style="width:350px"></a-input>
        </a-form-item>
        <a-form-item label="活动时间" name='end_time' required help='活动时间需与活动宣传的活动规则保持一致'>
          <a-range-picker v-model:value="time" :show-time="{ format: 'YYYY-MM-DD HH:mm' }" style="width:350px" valueFormat='YYYY-MM-DD HH:mm:ss' format='YYYY-MM-DD HH:mm:ss' @change="onChange" />
        </a-form-item>
        <a-form-item label="扫码模板" name='template_uuid' required>
          <a-row :gutter="16">
            <a-col :span="9">
              <a-input readonly placeholder='请选择关联模板' v-model:value="form.template_name" />
            </a-col>
            <a-col :span="8">
              <a-button type="primary" @click="templateVisible=true">选择</a-button>
            </a-col>
          </a-row>
        </a-form-item>
        <!-- 1'普通模板':2'云店模板'3'溯源模板' -->
        <a-form-item label="活动参与方式" name='award_type' v-if="form.template_type!=2">
          <a-radio-group v-model:value="form.award_type">
            <a-radio :value="2">直接领奖</a-radio>
            <a-radio :value="1">关注微信公众号领奖</a-radio>
          </a-radio-group>
          <div class="ant-form-explain s_cd41">（提示：选择关注领奖可能会被投诉停止访问，请谨慎选择，详见<a href="http://weixin.qq.com/cgi-bin/readtemplate?t=weixin_external_links_content_management_specification" target="_blank">微信新规</a>）</div>
        </a-form-item>
        <a-form-item label="活动规则" name='is_rule'>
          <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="form.is_rule"  />
        </a-form-item>
        <a-form-item label="规则标题" name='rule_title' v-if="form.is_rule">
          <a-input v-model:value="form.rule_title" placeholder='请输入规则标题'  style="width:350px"></a-input>
        </a-form-item>
        <a-form-item label="规则内容" name='rule_content' required v-show="form.is_rule">
          <div v-show="form.template_type!=7">
            <quill v-model:value="form.rule_content" :content="form.rule_content" />
          </div>
          <a-textarea v-model:value="form.rule_content" placeholder='请输入规则内容' showCount :rows="7" :maxlength="500" v-show="form.template_type==7" />
        </a-form-item>
        <a-form-item label="活动备注" name='remarks'>
          <a-textarea v-model:value="form.remarks" placeholder='请输入活动备注' showCount :rows="4" :maxlength="50"  style="width:350px"/>
        </a-form-item>
          <a-button type="primary" @click="next()" class="marigin_lr_auto">下一步</a-button>
      </a-form>
    </a-card>
     <a-modal title="选择模板" :keyboard="false" v-model:visible="templateVisible" centered  :width='1200' :footer="null" destroyOnClose v-if="templateVisible">
      <selectTemplate v-on:success="templateHandle" v-if="templateVisible" :template_type="form.template_type" :label_type="form.label_type" />
     </a-modal>
  </a-layout>
</template>

<script>
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import {
  activitysOneCreate,
  activitysOneDetail,
  activitysOneUpdate,
} from "@/api/qrcodeActivitys";
import { inject, provide, ref,onMounted } from "vue";
import { iscode } from "@/utils/app";
import { message } from 'ant-design-vue';

const labelCol = { span: 3 };
const wrapperCol = { span: 12 };


export default {
  props: {
    activity_id: {
      type: Number,
      default: () => {
        return null;
      },
    },
    label_type:{
      type:String,
      default: () => {
        return 'small';
      },
    },
    type:{
      type:String,
      default: () => {
        return 'add';
      },
    }
  },
  components: {
    InfoCircleOutlined
  },
  setup(props, { emit }) {
    let rule_content = async() =>{
      if (form.value.is_rule&&!form.value.rule_content) {
        return Promise.reject('请输入规则内容！');
      } else {
        return Promise.resolve();
      }
    }
    const rules = ref({
      activity_name: [
        {
          required: true,
          message: "请输入活动名称",
        },
      ],
      template_uuid: [
        {
          required: true,
          message: "请选择模板",
        },
      ],
      end_time: [
        {
          required: true,
          message: "请选择活动时间",
        },
      ],
      rule_content: [
        { required: true, validator: rule_content}
      ],
      rule_title: [
        {
          required: true,
          message: "请输入规则标题",
        },
      ],
    });
    const momentTime=inject('momentTime')
    const form = ref({
      activity_name: "",
      activity_type: 1, //先写死 活动类型
      start_time: "",
      end_time: "",
      template_uuid: "",
      award_type: 2,
      is_rule: 0,
      rule_title: "",
      rule_content: "",
      remarks: "",
      template_name:'',
      label_type:3,
      template_type:''
    });
    const time = ref(null);
    const ruleForm = ref();
    // 修改时间
    const onChange = (e) => {
      form.value.start_time = e[0];
      form.value.end_time = e[1];
    };
    // 获取详情
    const detail = async() => {
        let result = await activitysOneDetail(props.activity_id)
          .then((res) => res.data)
          .catch((error) => error);
        if (iscode(result)) {
          form.value=result.data
          time.value=[result.data.start_time,result.data.end_time]
          emit('template_type',form.value.template_type)
        }else{
          message.error(result.message)
        }
    };
    // 下一步
    const next = () => {
      if (props.activity_id) {
        update();
      } else {
        create();
      }
    };
    // 创建
    const create = () => {
      ruleForm.value.validate().then(async (res) => {
        let result = await activitysOneCreate({
          ...form.value,
          start_time:form.value.start_time,
          end_time:form.value.end_time,
          is_rule:form.value.is_rule?1:0
        })
          .then((res) => res.data)
          .catch((error) => error);
        if (iscode(result, true)) {
            emit("setpsOneDone", {...form.value,activity_id:result.data.activity_id});
        }
      }).catch(error => {
        message.error('请完善表单！');
      });
    };
    // 修改
    const update = () => {
      ruleForm.value.validate().then(async (res) => {
        let result = await activitysOneUpdate(props.activity_id, {...form.value,is_rule:form.value.is_rule?1:0})
          .then((res) => res.data)
          .catch((error) => error);
        if (iscode(result, true)) {
          emit("setpsOneDone", {...form.value,activity_id:result.data.activity_id});
        }
      }).catch(error => {
        message.error('请完善表单！');
      });
    };
    // 选择模板
    const templateVisible=ref(false)
    const templateHandle=(data)=>{
      form.value.template_uuid=data.template_uuid
      form.value.template_name=data.name
      form.value.template_type=data.type
      console.log(data.type)
      emit('template_type',data.type)
      templateVisible.value=false
    }
    onMounted(() => {
      if(props.type == 'add'){
        form.value.template_type = 1
      }
      
      if(props.label_type == 'big'&&props.type == 'add'){
        form.value.label_type = 2
      }
      
    });
    return {
      form,
      rules,
      ruleForm,
      time,
      labelCol,
      wrapperCol,
      onChange,
      create,
      update,
      detail,
      next,
      templateHandle,
      templateVisible
    };
  },
};
</script>